import React from "react"
import PropTypes from "prop-types"
import { Grid } from "semantic-ui-react"
import StoreCard from "./StoreCard"

const StoreHolder = (props) => {
  const { stores, currentStore, deleteStore, editStore, selectStore } = props

  const cards = stores.map((e, idx) => {
    return (
      <Grid.Column key={e.id} computer={8} tablet={16} data-test="mainGrid">
        <StoreCard
          {...e}
          id={e.id}
          key={e.id + idx}
          deleteStore={deleteStore}
          editStore={editStore}
          selectStore={selectStore}
          stores={stores}
          currentStore={currentStore}
          // isLoading={contains(e.employeeId, loadingEmployeeIds)}
        />
      </Grid.Column>
    )
  })
  return <Grid>{cards}</Grid>
}

export default StoreHolder

StoreHolder.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      address: PropTypes.string,
    }),
  ),
  // loadingEmployeeIds: PropTypes.arrayOf(PropTypes.number),
  // createStore: PropTypes.func.isRequired,
  deleteStore: PropTypes.func,
  editStore: PropTypes.func,
}
